import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function valueSelectedValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        return control.value === '' ? { valueSelected: { value: control.value } } : null;
    };
}
